/** Night anywhere out of the schools: a soft zheng under the moon, a xiao, crickets in the grass. */
import { arp, drone } from '../compose';
import { registerTrack } from '../registry';

const A_ZHENG = `@mp 6,g 1_ 2_ 3 2_ 1_ | 6,\\- 5, 6, | 1. 2_ 3 5^ | 3-~-- |
  6. 5_ 3 2/ | 1_ 2_ 3_ 2_ 1 6, | 5,_ 6,_ 1_ 2_ 3 2 | 6,-~--`;
const A_XIAO = `0--- | 0--- | 0--- | 0--- | @p 3--- | 5- 6- | 5- 3- | 6,---`;
const ROOTS_A = `6,, 3,, 1, 3,, 6,, 1, 5,, 6,,`;

const B_XIAO = `@mp 6. 1'_ 6 5 | 3- 5 3 | 2. 3_ 5 6 | 3--- ; | 5. 6_ 1' 2' | 1'_ 6_ 5 6- | 3_ 5_ 3_ 2_ 1 2 | 6,---`;
const B_ZHENG = `@p 3'* 0- 0 | 0- 6* 0 | 2'* 0- 0 | 0- 5* 0 | 1'* 0- 0 | 0- 3* 0 | 2'* 0- 0 | 6* 0--`;
const ROOTS_B = `6,, 1, 2, 3,, 5,, 1, 3,, 6,,`;

const CRICKETS = `n--- | 0--- | n--- | 0--- | 0--- | n--- | 0--- | n---`;

registerTrack({
  id: 'night',
  order: 13,
  title: 'ราตรีใต้แสงจันทร์',
  mood: 'เงียบสงบ อ้างว้าง ราตรี',
  use: 'ยามค่ำคืน (เมืองและแผนที่ที่ไม่มีเพลงกลางคืนของตัวเอง)',
  key: 'G',
  mode: 'yu',
  bpm: 60,
  meter: 4,
  seed: 1313,
  humanize: 0.6,
  parts: {
    zheng: { inst: 'zheng', gain: 0.85, pan: 0.1, reverb: 0.45 },
    harp: { inst: 'zheng', gain: 0.38, pan: -0.25, reverb: 0.45 },
    xiao: { inst: 'xiao', gain: 0.85, pan: -0.15, reverb: 0.55 },
    pad: { inst: 'pad', gain: 0.55, reverb: 0.55 },
    crickets: { inst: 'perc', gain: 0.05, pan: 0.4, reverb: 0.3 },
  },
  sections: {
    A: {
      bars: 8,
      parts: {
        zheng: A_ZHENG,
        xiao: A_XIAO,
        harp: arp(ROOTS_A, [0, 3, 5, 3, null, 3, 5, null]),
        pad: drone(ROOTS_A, 4),
        crickets: CRICKETS,
      },
    },
    B: {
      bars: 8,
      parts: {
        xiao: B_XIAO,
        zheng: B_ZHENG,
        harp: arp(ROOTS_B, [0, null, 3, null, 5, null, 3, null]),
        pad: drone(ROOTS_B, 4),
        crickets: CRICKETS,
      },
    },
    A2: {
      bars: 8,
      parts: {
        zheng: A_ZHENG,
        xiao: `@p 0--- | 0--- | 3--- | 2- 1- | 3--- | 5- 6- | 5- 3- | 6,---`,
        harp: arp(ROOTS_A, [0, 3, 5, 6, 5, 3, null, null]),
        pad: drone(ROOTS_A, 4),
        crickets: CRICKETS,
      },
    },
  },
  form: ['A', 'B', 'A2', 'B'],
  loop: true,
});
